export const addQueryParams = (params) => {
    const paramStrings = Object.keys(params).reduce((acc, key, index) => {
      acc.push(key + "=" + params[key]);
      return acc;
    }, []);
    return paramStrings.join("&");
  };